const buildKey = (teamId) => `thebox_activeSeasonId_${teamId}`;

const normalizePayload = (value) => {
  if (!value) return { seasonId: null, seasonYear: null };
  if (typeof value === 'object') {
    const seasonId = value.seasonId != null ? String(value.seasonId) : null;
    const seasonYear = value.seasonYear != null ? String(value.seasonYear) : null;
    return { seasonId, seasonYear };
  }
  const key = String(value);
  return { seasonId: key, seasonYear: null };
};

const parseStoredSelection = (rawValue) => {
  if (!rawValue) return { seasonId: null, seasonYear: null };
  try {
    const parsed = JSON.parse(rawValue);
    return normalizePayload(parsed);
  } catch (_) {
    return normalizePayload(rawValue);
  }
};

const toPrimaryValue = (payload, preferYear = false) => {
  if (preferYear) return payload.seasonYear || payload.seasonId || null;
  return payload.seasonId || payload.seasonYear || null;
};

export const getSeasonSelectionPayload = (teamId) => {
  if (!teamId) return null;
  const raw = localStorage.getItem(buildKey(teamId));
  return parseStoredSelection(raw);
};

export const getSeasonSelection = (teamId, options = {}) => {
  if (!teamId) return null;
  const payload = getSeasonSelectionPayload(teamId);
  return toPrimaryValue(payload || { seasonId: null, seasonYear: null }, options.preferYear);
};

export const setSeasonSelection = (teamId, seasonValue) => {
  if (!teamId) return;
  const payload = normalizePayload(seasonValue);
  const primaryValue = toPrimaryValue(payload, false);
  const key = buildKey(teamId);
  if (primaryValue) {
    localStorage.setItem(key, JSON.stringify(payload));
  } else {
    localStorage.removeItem(key);
  }

  window.dispatchEvent(
    new CustomEvent('thebox-season-change', {
      detail: {
        teamId,
        seasonId: payload.seasonId,
        seasonYear: payload.seasonYear,
      },
    })
  );
};

export const subscribeSeasonSelection = (teamId, callback, options = {}) => {
  if (!teamId || typeof callback !== 'function') return () => {};

  const key = buildKey(teamId);
  const preferYear = Boolean(options.preferYear);
  const emit = (payload) => {
    const normalized = normalizePayload(payload);
    callback(toPrimaryValue(normalized, preferYear), normalized);
  };

  const eventHandler = (event) => {
    if (event?.detail?.teamId !== teamId) return;
    emit({
      seasonId: event.detail.seasonId || null,
      seasonYear: event.detail.seasonYear || null,
    });
  };

  const storageHandler = (event) => {
    if (event.key !== key) return;
    emit(parseStoredSelection(event.newValue || null));
  };

  window.addEventListener('thebox-season-change', eventHandler);
  window.addEventListener('storage', storageHandler);

  return () => {
    window.removeEventListener('thebox-season-change', eventHandler);
    window.removeEventListener('storage', storageHandler);
  };
};
